import React from "react";

export const Roadmap = () => {
  return (
    <div>
      <h1>Roadmap</h1>
    </div>
  );
};
